export default function useMediaQueriyFunc() {
  function breakpoint(size: string): number {
    switch (size) {
      case 'xs':
        return 0;
      case 'sm':
        return 576;
      case 'md':
        return 960;
      case 'lg':
        return 1240;
      default:
        return 0;
    }
  }

  /**
   * xsサイズの場合は
   * @returns xsサイズの場合は true
   */
  function xs(winWidth?: number) : boolean {
    let width = window.innerWidth;
    if (winWidth) {
      width = winWidth;
    }
    return width <= breakpoint('sm') && width >= breakpoint('xs');
  }

  /**
   * smサイズの場合は
   * @returns smサイズの場合は true
   */
  function sm(winWidth?: number) : boolean {
    let width = window.innerWidth;
    if (winWidth) {
      width = winWidth;
    }
    return width <= breakpoint('md') && width > breakpoint('sm');
  }

  /**
   * mdサイズの場合は
   * @returns mdサイズの場合は true
   */
  function md(winWidth?: number) : boolean {
    let width = window.innerWidth;
    if (winWidth) {
      width = winWidth;
    }
    return width <= breakpoint('lg') && width > breakpoint('md');
  }

  /**
   * lgサイズの場合は
   * @returns lgサイズの場合は true
   */
  function lg(winWidth?: number) : boolean {
    let width = window.innerWidth;
    if (winWidth) {
      width = winWidth;
    }
    return width >= breakpoint('lg');
  }

  return {
    xs,
    sm,
    md,
    lg,
  };
}
